import { scoreRules } from '@internal/backstage-plugin-aws-services';

import {
  CustomHealthCard,
  HealthScoreCard,
  SimpleScore,
} from '@internal/ui-common';

interface SecretsScoreCardProps {
  title: string;
  tooltip: string;
  deepLinkTitle: string;
  score: SimpleScore;
  link: string;
}

function SecretsScoreCard({
  tooltip,
  deepLinkTitle,
  score,
  link,
}: Readonly<SecretsScoreCardProps>) {
  return (
    <CustomHealthCard
      title="Secrets"
      tooltip={tooltip}
      deepLink={{ title: deepLinkTitle, link: link }}
    >
      <HealthScoreCard
        score={score}
        scoreRules={scoreRules}
        trendInfo={{ enabled: false }}
      />
    </CustomHealthCard>
  );
}

export { SecretsScoreCard };
